import React from "react";
import Header from "./components/Header";
import { Grid, Modal, Row } from 'meitav-uikit';
import * as Constants from "./utils/constants";

import "./App.scss";
import "styles/_mui-overrides.scss"

export default function Layout({ children, lobby }) {
  if (children) {
    return (
      <Grid layout="join">
        <Modal />
        <Header lobby={lobby} />
        <main dir="rtl">{children}</main>
        <Row className="accessibilityFooter">
          <a
            className="footer-links"
            target="_blank"
            rel="noreferrer"
            href={Constants.ACCESSIBILITY_LINK}
          >
            הצהרת נגישות
          </a>
        </Row>
      </Grid>
    );
  }
  return "";
}
